export const LOCALES = ["it", "en", "es"];
